var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-tag_svg__clip0_6809_3027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.407 5.39h.007M1.399 3.52v2.99c0 .326 0 .49.037.643.033.137.087.267.16.387.082.134.198.25.429.48l5.123 5.123c.793.794 1.19 1.19 1.647 1.34.403.13.837.13 1.239 0 .458-.15.854-.546 1.648-1.34l1.477-1.477c.794-.794 1.19-1.19 1.34-1.648.13-.402.13-.836 0-1.238-.15-.458-.546-.855-1.34-1.648L8.037 2.009c-.231-.231-.347-.347-.482-.43a1.336 1.336 0 00-.386-.16c-.153-.036-.317-.036-.644-.036H3.536c-.748 0-1.122 0-1.408.146a1.336 1.336 0 00-.583.583c-.146.286-.146.66-.146 1.409zM5.74 5.39a.334.334 0 11-.668 0 .334.334 0 01.668 0z",
    stroke: "#fff",
    strokeWidth: 1.202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-tag_svg__clip0_6809_3027"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.063 .047)",
    d: "M0 0h16.032v16.032H0z"
  })))));
}
export default SvgIconTag;